import { EXPENSES } from '../../../../shared/constants';
import { IMultiSelectDropDownOption } from '../../../___design/MultiSelectDropDownInput/MultiSelectDropDownInput.types';
import { IListingDetailForm } from '../ListingDetailForm.types';

export const getRentExpenseOptions = (values: IListingDetailForm) => {
  const tenant_expense_value = [
    ...(values?.tenant_expense || []).map(
      (item: IMultiSelectDropDownOption) => item.value,
    ),
  ];
  const landlord_expense_value = [
    ...(values?.landlord_expense || []).map(
      (item: IMultiSelectDropDownOption) => item.value,
    ),
  ];
  return Object.values(EXPENSES).map(({ label, value }) => ({
    label,
    value,
    isDisabled: [...tenant_expense_value, ...landlord_expense_value].includes(
      value,
    ),
  }));
};
